import React, { FC } from "react";
import { Flex, LinearProgress } from "@evergis/ui";

import { Attribute } from "./Attribute";

import { AttributesListProps } from "./types";

export const AttributesList: FC<AttributesListProps> = ({ attributes, visibility, loading }) => {
  if (loading) {
    return <LinearProgress />;
  }

  return (
    <Flex column style={{ gap: "1.5rem" }}>
      {attributes.reduce((acc, attribute) => {
        if (!visibility?.[attribute.name]) {
          return acc;
        }

        return [...acc, <Attribute key={`attribute-list-${attribute.name}`} attribute={attribute} />];
      }, [])}
    </Flex>
  );
};
